import { createFileRoute } from '@tanstack/react-router';
import { canOpenReconcile } from '@promanage/core';
import { useQuery } from '@tanstack/react-query';
import { TopBar } from '../components/TopBar';
import { ReconcileNav } from '../features/reconcile/ReconcileNav';
import { requireAccess } from '../features/auth/routeAccess';
import { AgeingBands } from '../features/suspense/AgeingBands';
import { SuspenseQueue } from '../features/suspense/SuspenseQueue';
import { trpc } from '../lib/trpc';

export const Route = createFileRoute('/reconcile/suspense')({
  beforeLoad: requireAccess(canOpenReconcile),
  component: SuspensePage,
});

/**
 * Suspense — TRUST_ACCOUNTING.md §5, on the screen that is meant to make it uncomfortable.
 *
 * A THIRD RECONCILE SCREEN, and the three ask genuinely different questions. `/reconcile` asks
 * what the bank has SHOWN, one day at a time. `/reconcile/queue` asks whose money each bank line
 * IS, across days. This one asks about money we have already taken in and could not name — it is
 * not a bank line any more, it is a balance, and it is the balance that refuses a month close.
 *
 * UNDER `/reconcile` rather than in the rail, because nobody opens this first thing in the
 * morning. It is where the dashboard tile sends you when the ageing has something to say, and
 * where the month-close dialog sends you when it refuses.
 */
function SuspensePage() {
  const held = useQuery(
    trpc.suspense.list.queryOptions(
      {},
      // Short, like the review queue's: at month end two people work this list at once, and a
      // deposit placed by one must stop being offered to the other quickly.
      { staleTime: 5_000 },
    ),
  );

  return (
    <div className="mx-auto max-w-[var(--content-max)] pb-4">
      <TopBar title="Suspense" subtitle="Money we are holding for somebody we cannot name" />
      <ReconcileNav />

      <div className="flex flex-col gap-4">
        {held.data ? <AgeingBands held={held.data} /> : null}
        <SuspenseQueue held={held.data} isPending={held.isPending} />
      </div>
    </div>
  );
}
